import React, {Fragment, lazy, Suspense} from "react";
import apiAddress from "../services/api/apiAddress"
// eslint-disable-next-line
import {NavLink, withRouter, history} from "react-router-dom"; // leave it like that !
import ReactHtmlParser from 'react-html-parser';
import SearchBar from "../componentsBange/searchBar/SearchBar";
import PdfComponent from "../componentsBange/PdfComponent/PdfComponent";
import {loginUser, logout} from "../reducers/authentication/actions";
import image from '../assets/images/image.svg';
import audio from '../assets/images/audio.svg';
import audioSpecial from '../assets/images/special_audio.svg';
import videoSpecial from '../assets/images/special_video.svg';
import imageSpecial from '../assets/images/special_image.svg';
import textSpecial from '../assets/images/special_text.svg';
import video from '../assets/images/video.svg';
import text from '../assets/images/text.svg';
// TODO: LEAVE THIS HERE IF YOU WANT BANGE STYLES
// eslint-disable-next-line
import bangeBookStyles from '../styles/bange-book-template.css'
import TocIcon from '@material-ui/icons/TocRounded';
import RightIcon from '@material-ui/icons/KeyboardArrowRight';
import LeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Tooltip from '@material-ui/core/Tooltip';
import queryString from 'query-string'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import GetAppIcon from '@material-ui/icons/GetApp';

import Lottie from 'lottie-react-web'
import loader from '../assets/images/loader.json';
import './viewer.css';
import {fetchBookByAuthorAndTitle, fetchChapterById} from '../reducers/content/actions';
import {isMobile} from "../utils/device";
import {orderBook} from '../reducers/order/actions';
import {connect} from 'react-redux';
import {getUserActiveSubscription} from "../reducers/user/actions";
import {searchInBook} from "../reducers/content/actions";
import AwesomeDebouncePromise from 'awesome-debounce-promise';

import MainFooter from "../components/layout/MainFooter"
import Https from "../services/api/apiClient";

import {addSlashes, empty} from "../modules/Functions";


const ViewerModal = lazy(() => import('./ViewerModal'));

const renderLoader = () => {
    return (<div style={{position: "fixed", left: "50%", top: "50%", marginLeft: "-35px"}}>
        {/*eslint-disable-next-line*/}
        <Lottie style={{width: "70px", margin: "0px"}}
                options={{
                    animationData: loader,
                }}/></div>)
};
/**
 * mediaImageURLs mit svg eintraegen fuellen, fuer die icons in der sidebar
 *
 * @param mediaTypes
 * @returns {*[]}
 */
const parseMediaTypes = (mediaTypes) => {
    let mediaImageURLs = [];

    for (let mediaType in mediaTypes) {
        switch (mediaTypes[mediaType]) {
            case "image":
                mediaImageURLs.push(image);
                break;
            case "video":
                mediaImageURLs.push(video);
                break;
            case "audio":
                mediaImageURLs.push(audio);
                break;
            default:
                break;
        }
    }

    return mediaImageURLs;
}

/**
 * Rendert die Kapiteleintraege in der Sidebar
 *
 * @param chapter
 * @param onChapterSelected
 * @param currentChapterId
 * @param searchTerm
 * @param index
 * @param searchResults
 * @returns {JSX.Element}
 * @constructor
 */
const ChapterItem = ({chapter, onChapterSelected, currentChapterId, searchTerm, index, searchResults}) => {
    const isBold = chapter.attributes.includes("b");
    var className = chapter.className + " contentsElement";
    //eslint-disable-next-line
    if (currentChapterId === chapter.chapter) className += " active";
    // check if chaptername includes searchterm
    // then split it and highlight searchterm
    let chaptername = chapter.text;
    let contains = chaptername.toLowerCase().includes(searchTerm.toLowerCase());

    // check if any chapter contains searchTerm
    if (searchResults && (searchResults.length > 0)) {
        searchResults.forEach((searchResultChapter) => {
            if (searchResultChapter.subChapterName.length > 0) {
                // is subchapter, check if match
                if (chapter.subChapterName === searchResultChapter.subChapterName) {
                    contains = true;
                }
            } else {
                if (chapter.chapterName === searchResultChapter.chapterName) {
                    contains = true;
                }
            }
        });
    }

    if (searchTerm.length > 0) {
        var regex = new RegExp(searchTerm, "gi");
        if (chaptername && regex.test(chaptername)) {
            var indexSearchTerm = chaptername.search(regex);
            var dataTemp = [];
            //eslint-disable-next-line
            while (indexSearchTerm !== -1) {
                // first add text before searchTerm
                dataTemp.push(<span>{chaptername.substring(0, indexSearchTerm)}</span>);
                let result = chaptername.substring(indexSearchTerm, (indexSearchTerm + searchTerm.length))
                dataTemp.push(<span className="searchResultChapterName">{result}</span>);
                // remove this part from the string
                chaptername = chaptername.slice((indexSearchTerm + searchTerm.length), chaptername.length);
                // next searchterm
                indexSearchTerm = chaptername.search(regex);
            }
            // append rest of sentence if there is any
            if (chaptername.length > 0) dataTemp.push(<span>{chaptername}</span>);
            chaptername = (<span>{dataTemp}</span>);
        }
    }

    className += (contains) ? " lookup" : " lookup-false";
    // check for media types
    let mediaImageURLs = [];
    if (chapter.zusatz) {
        if (chapter.zusatz.length > 0) {
            // get file type for media types
            let mediaTypes = [];
            for (let i = 0; i < chapter.zusatz.length; i++) {
                let fileType = chapter.zusatz[i].split(".").pop();
                let mediaType = "";
                switch (fileType) {
                    case "png":
                        mediaType = "image";
                        break;
                    case "jpg":
                        mediaType = "image";
                        break;
                    case "mp4":
                        mediaType = "video";
                        break;
                    case "mp3":
                        mediaType = "audio";
                        break;
                    default:
                        break;
                }
                if (!mediaTypes.includes(mediaType)) mediaTypes.push(mediaType);
            }
            mediaImageURLs = parseMediaTypes(mediaTypes);
        }
    }

    if (!chapter.text.length > 0) return <></>;
    return (
        <Fragment>
            <div
                key={chapter.chapterName + chapter.subChapterName}
                className={className}
                style={isBold ? {} : {}}
                onClick={() => onChapterSelected(chapter.chapter, chapter.subChapterName, index, false)}
            >
                {chaptername}
            </div>
            {mediaImageURLs.length > 0 &&
                (chapter.className === 'TOC-E2' || (chapter.chapterName === 'ch06' && chapter.className === 'TOC-E1')) &&
                <div className={"bookPreviewCardMediaTypesContainer mb-2 pt-1 " + className}
                     onClick={() => onChapterSelected(chapter.chapter, chapter.subChapterName, index, true)}>
                    {mediaImageURLs.map((mediaImageURL, index) => {
                        let fileType = mediaImageURL.split("/").pop().split(".")[0];
                        let mediaType;
                        switch (fileType) {
                            case "image":
                                mediaType = "Bild";
                                break;
                            case "audio":
                                mediaType = "Audio";
                                break;
                            case "video":
                                mediaType = "Video";
                                break;
                            default:
                                break;
                        }
                        return <Tooltip key={index} title={mediaType} aria-label={mediaType}>
                            <img alt={mediaType} src={mediaImageURL}/>
                        </Tooltip>
                    })}
                </div>}
        </Fragment>
    );
};


class Viewer extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            currentChapterId: null,
            searchTerm: "",
            modalState: "closed", //after
            modalAction: null,
            email: "",
            password: "",
            readerHeight: null,
            readerWidth: 1,
            windowHeight: window.innerHeight,
            paymentId: null,
            subId: null,
            disableContent: true,
            checkoutSubscribe: false,
            checkoutPurchase: false,
            lockPage: false,
            contentListOpen: false,
            noSubError: true,
            togglePageUpButton: false,
            togglePageUpButtonReader: false,
            loading: false,
            openSidebar: true,
            openSelectAudio: false,
            openSelectImage: false,
            openSelectText: false,
            openSelectVideo: false,
            format: ''
        }
        this.readerContainer = React.createRef();
        this.contentContainer = React.createRef();
        this.isScrolling = null;
        this.hasListener = false;
        // Search function
        this.searchBookDebounced = AwesomeDebouncePromise(this.searchBook, 300);
    }

    // Lifecycle
    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        window.addEventListener('touchmove', this.scrollFunction);
        window.addEventListener('scroll', this.scrollFunction, true);

        const {currentBook} = this.props;
        const {params} = this.props.match;
        if (!currentBook
            || (currentBook.originalAuthor !== params.author && currentBook.title !== params.title
            )) {
            this.props.fetchBookByAuthorAndTitle(params.author, params.title, (book) => {
                if (!book.title) {
                    alert('Der gewünschte Titel wurde nicht gefunden');
                    this.props.history.push("/");
                }
                this.renderMetaInformation();

                if (params.id && this.state.currentChapterId !== params.id) {
                    this.handleChapterSelected(params.id);
                } else {
                    this.handleChapterSelected(this.props.currentBook.chapters[0].chapter);
                }
                this.setState({format: book.format ? book.format : 'epub2'});
            })
            // set loading spinner
            this.setState({loading: true});

        }
        // get Ids from URL for Checkout, if there are any
        if (this.props.location.search.length > 0) {
            const values = queryString.parse(this.props.location.search);
            // check if user is logged in
            //eslint-disable-next-line
            if (this.props.authenticated) {
                if (values.paymentId) {
                    // TODOcheck if user already has access
                    this.setState({
                        paymentId: values.paymentId,
                        checkoutPurchase: true,
                        noSubError: true,
                        openModal: true,
                        lockPage: false
                    });

                }
                if (values.subId) {
                    // check if user already subscribed, lockPage for this
                    this.setState({lockPage: true});
                    this.props.getUserActiveSubscription("egal", () => {
                        // user has subscription
                        this.setState({checkoutSubscribe: false, noSubError: false, lockPage: false});
                    }, () => {
                        // user has no subscription
                        this.setState({
                            subId: values.subId,
                            checkoutSubscribe: true,
                            noSubError: true,
                            openModal: true,
                            lockPage: false
                        });
                    })
                }
            }
        }

        if (isMobile) document.body.classList.add('isMobile');

        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        window.removeEventListener('touchmove', this.scrollFunction);
        window.removeEventListener('scroll', this.scrollFunction);

        let searchbar = document.getElementById("contentSearch");
        if (searchbar && this.hasListener) {
            searchbar.firstChild.firstChild.removeEventListener("focus", () => {
                document.getElementById("contentSearch").firstChild.classList.add("searchfocus");
            });
            searchbar.firstChild.firstChild.removeEventListener("blur", () => {
                document.getElementById("contentSearch").firstChild.classList.remove("searchfocus");
            });
            this.hasListener = false;
        }
        window.clearTimeout(this.isScrolling);
        this.isScrolling = null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {currentBook} = this.props;
        if (currentBook && currentBook !== prevProps.currentBook && !this.state.nextButton) {
            this.setState({nextButton: 'Jetzt bestellen'});
            if (currentBook) {
                Https.get('/api/v1/order/isAvailable?bookid=' + currentBook._id)
                    .then(
                        res => {
                            if (res && res.data && res.data.data.available) {
                                this.setState({nextButton: 'Weiter'});
                                document.body.classList.add('customer_bought_this');
                            }
                        },
                        error => {
                        }
                    );
                Https.get('/api/v1/codes/isAvailable?bookid=' + currentBook._id)
                    .then(
                        res => {
                            if (res && res.data && res.data.data.available) {
                                this.setState({nextButton: 'Weiter'});
                                document.body.classList.add('customer_bought_this');
                            }
                        },
                        error => {
                        }
                    );
            }
        }

        if (currentBook && this.state.currentChapterId && prevState.currentChapterId !== this.state.currentChapterId) {
            this.fetchChapter();
        } else if (currentBook && this.state.currentChapterId && this.props.match.params.id && this.props.match.params.id !== this.state.currentChapterId) {
            this.setState({currentChapterId: this.props.match.params.id}, () => this.fetchChapter());
        }
    }


    scrollFunction = () => {
        // Clear our timeout throughout the scroll
        window.clearTimeout(this.isScrolling);

        // Set a timeout to run after scrolling ends
        this.isScrolling = setTimeout(() => {

            // Run the callback
            if (this.contentContainer) {
                if (this.contentContainer.scrollTop > (this.contentContainer.offsetHeight / 3)) {
                    this.setState({togglePageUpButton: true});
                } else {
                    this.setState({togglePageUpButton: false});
                }
            }

            // reader container

            if (this.readerContainer) {
                if (this.readerContainer.scrollTop > (this.readerContainer.offsetHeight / 3)) {
                    this.setState({togglePageUpButtonReader: true});
                } else {
                    this.setState({togglePageUpButtonReader: false});
                }
            }
        }, 66);
    }

    searchBook = (text) => {
        this.props.searchInBook(this.props.currentBook._id, text, (results) => {
        }, () => {

        })
    }

    getLastChapter() {
        try {
            for (var i = 0; i < this.props.currentBook.chapter.length; i++) {

            }
        } catch (err) {

        }
    }

    updateDimensions = () => {
        this.setState({windowHeight: window.innerHeight});
    };

    loadChapterSuccess = () => {
        this.setState({loading: false});

        this.scrollToAnker();
        // stop video if playing
        let video = document.getElementById("videoPlayer");
        if (video) {
            video.load();
        }
    }

    loadChapterFailure = (err) => {
        if (err.toString().indexOf('Request failed with status code 409') >= 0) {
            this.props.logoutUser(() => {
                window.location.href = '/';
            }, () => {
                window.location.href = '/';
            });
        } else {
            try {
                this.setState({noSubError: true, openModal: true, loading: false});
                this.handleChapterSelected(this.props.currentBook.chapters[0].chapter);
            } catch (error) {

            }
        }
    }

    fetchChapter() {
        const {currentBook} = this.props;
        const {currentChapterId} = this.state;
        if (currentChapterId && currentBook) {
            this.props.fetchChapterById(currentChapterId, this.loadChapterSuccess, this.loadChapterFailure);
        }
    }

    scrollToZusatz() {
        const zusatzAnker = document.getElementsByClassName("zusatz")[0];
        if (zusatzAnker) zusatzAnker.scrollIntoView();
    }

    handleChapterSelected = (chapterId, subChapter, chapterIndex, scrollToZusatz, scrolltoFootnote, footnoteValue) => {
        // check for same chapter click, then scroll top
        // eslint-disable-next-line
        if (chapterId === this.state.currentChapterId && subChapter === this.state.subChapter) {
            if (!scrollToZusatz) {
                if (document.getElementById("readerContainer").scrollTop !== 0) {
                    document.getElementById("readerContainer").scrollTo(0, 0);
                } else {
                    this.scrollToAnker()
                }
            }
        } else {
            if (this.state.currentChapterId && chapterId !== this.state.currentChapterId) {
                this.props.history.push('/' + this.props.currentBook.link + '/' + chapterId + '/');
            }
        }
        if (scrollToZusatz) {
            this.setState({
                    currentChapterId: chapterId,
                    subChapter: subChapter,
                    chapterIndex: chapterIndex,
                    contentListOpen: false,
                    openModal: false
                },
                () => {
                    setTimeout(() => this.scrollToZusatz(), 200);
                });
        } else if (scrolltoFootnote) {
            this.setState({
                    currentChapterId: chapterId,
                    subChapter: subChapter,
                    chapterIndex: chapterIndex,
                    contentListOpen: false,
                    openModal: false
                },
                () => {
                    var zusatzAnker = document.getElementsByClassName("footnote-anchor");
                    zusatzAnker = zusatzAnker[footnoteValue - 1];
                    if (zusatzAnker) zusatzAnker.scrollIntoView();
                });
        } else {
            // check if modal is open in first chapter
            if (parseInt(chapterIndex) === 0 && this.state.openModal === true) {
                this.setState({
                    currentChapterId: chapterId,
                    subChapter: subChapter,
                    chapterIndex: chapterIndex,
                    contentListOpen: false,
                    openModal: false
                });
            } else this.setState({
                currentChapterId: chapterId,
                subChapter: subChapter,
                chapterIndex: chapterIndex,
                contentListOpen: false
            });
        }
    }

    handleClickFootnote = (number) => {
        // change to footnote chapter, if footnotes are the last chapter....

        let chap = '';
        for (let i = 0; i < this.props.currentBook.chapters.length; i++) {
            if (this.props.currentBook.chapters[i].fileName.toLowerCase() === 'fn.xhtml') {
                chap = this.props.currentBook.chapters[i].chapter;
                break;
            }
        }
        this.handleChapterSelected(chap, "", null, null, true, number);
    }

    transform = (node) => {
        if (node && node.attribs && node.attribs.src) {
        }
        if (node.type === 'tag' && node.name === 'h1') {
            return (<h2 className={'headline'}>{node.children[0].data}</h2>);
        }

        if (node.type === 'tag' && node.name === 'a' && node.attribs.href && node.attribs.class && node.attribs.class === "datensammlung") {
            return (<div className={'link_container datensammlung'}>
                <a target={'_blank'}
                   href={apiAddress + "/api/v1/content/books/media/" + this.props.currentBook.isbn + "/" + node.attribs.href.substring(3)}>
                    {node.children[0].data}
                </a>
            </div>);
        }

        if (node.type === 'tag' && node.name === 'img' && node.attribs.src) {
            // add current book isbn as folder path
            //node.attribs.src = apiAddress + "/api/v1/content/books/media/" + this.props.currentBook.isbn + "/" + node.attribs.src.substring(3);
            // get attributes
            let altText = node.attribs.alt ? node.attribs.alt : "";
            let titleText = node.attribs.title ? node.attribs.title : "";
            // return new html img element with context menu etc. disabled

            let datensammlung = node.attribs.class && node.attribs.class === "datensammlung";

            if (datensammlung) {
                const imgName = node.attribs.src.substring(3).split('/').pop();
                return (
                    <div className={'img_container' + (datensammlung ? ' datensammlung' : '')}>
                        <img
                            alt={altText}
                            title={titleText}
                            src={apiAddress + "/api/v1/content/books/media/" + this.props.currentBook.isbn + "/" + node.attribs.src.substring(3)}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                return false
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                return false
                            }}
                        />
                        <a download={imgName}
                           href={apiAddress + "/api/v1/content/books/mediadownload/" + this.props.currentBook.isbn + "/" + node.attribs.src.substring(3)}>
                            <GetAppIcon/>
                        </a>
                    </div>
                )
            } else {
                return (
                    <img
                        style={{maxWidth: "96%"}}
                        alt={altText}
                        title={titleText}
                        src={apiAddress + "/api/v1/content/books/media/" + this.props.currentBook.isbn + "/" + node.attribs.src.substring(3)}
                    />
                )
            }
        }

        // links to footnotes
        if (node.type === 'tag' && node.name === 'a' && node.attribs.class === "footnote-link") {
            return <a className={node.attribs.class} id={node.attribs.id} href="/#"
                      onClick={() => this.handleClickFootnote(node.children[0].data)}>
                {node.children[0].data}
            </a>;
        }

        // links from footnotes
        if (node.type === 'tag' && node.name === 'a' && node.attribs.class === "footnote-anchor") {
            let re = new RegExp("(ch.*)#(.*)");
            let res = re.exec(node.attribs.href);
            let fileName = '';
            let chapter = '';
            let subchapter = '';
            if (Array.isArray(res) && res.length === 3) {
                fileName = res[1];
            }
            for (let i = 0; i < this.props.currentBook.chapters.length; i++) {
                if (this.props.currentBook.chapters[i].fileName === fileName) {
                    chapter = this.props.currentBook.chapters[i].chapter;
                    subchapter = this.props.currentBook.chapters[i].subChapterName;
                    break;
                }
            }
            return <a className={node.attribs.class} id={node.attribs.id} href="/#"
                      onClick={() => this.handleChapterSelected(chapter, subchapter)}>
                {node.children[0].data}
            </a>;

        }

        // check for Ueberschrift table and create mobile optimized version
        if (node.type === 'tag' && node.name === 'table' && node.attribs.class === "Ueber1") {
            //<table class="Ueber1"><tbody><tr valign="top"><td>1.</td><td>Das Wichtigste auf einen Blick – Schnellübersicht</td></tr></tbody></table>
            if (isMobile) {

                let chapterNr = node.children[1].children[1].children[1].children[0].data;
                let chapterName = node.children[1].children[1].children[3] ? node.children[1].children[1].children[3].children[0].data : '';
                // replace tbody
                return (
                    <table className="Ueber1">
                        <tbody>
                        <tr valign="top">
                            <td>{chapterNr}</td>
                        </tr>
                        <tr valign="top">
                            <td>{chapterName}</td>
                        </tr>
                        </tbody>
                    </table>
                )
            }
        }
        // check for searchterm in chapter
        const {searchTerm} = this.state;
        if (searchTerm.length > 0) {
            // search all text
            if (node.type === "text" && node.data) {
                let data = node.data;
                let regex = new RegExp(searchTerm, "gi");
                if (data && regex.test(data)) {
                    let indexSearchTerm = data.search(regex);
                    let dataTemp = [];
                    //eslint-disable-next-line
                    while (indexSearchTerm !== -1) {
                        // first add text before searchTerm
                        dataTemp.push(<span>{data.substring(0, indexSearchTerm)}</span>);
                        let result = data.substring(indexSearchTerm, (indexSearchTerm + searchTerm.length))
                        dataTemp.push(<span className="searchResult">{result}</span>);
                        // remove this part from the string
                        data = data.slice((indexSearchTerm + searchTerm.length), data.length);
                        // next searchterm
                        indexSearchTerm = data.search(regex);
                    }
                    // append rest of sentence if there is any
                    if (data.length > 0) dataTemp.push(<span>{data}</span>);
                    return (<span>{dataTemp}</span>)
                }

            }

            // search all bold text
            if (node.type === "tag" && node.name === 'b') {
                let data = node.children[0].data;
                // create regex for case insensitive match
                var regex = new RegExp(searchTerm, "i");
                if (data && regex.test(data)) {
                    let indexSearchTerm = data.search(regex);
                    var dataTemp = [];
                    //eslint-disable-next-line
                    while (indexSearchTerm !== -1) {
                        // first add text before searchTerm
                        dataTemp.push(<span>{data.substring(0, indexSearchTerm)}</span>);
                        let result = data.substring(indexSearchTerm, (indexSearchTerm + searchTerm.length))
                        dataTemp.push(<b className="searchResult">{result}</b>);
                        // remove this part from the string
                        data = data.slice((indexSearchTerm + searchTerm.length), data.length);
                        // next searchterm
                        indexSearchTerm = data.search(searchTerm);
                    }
                    // append rest of sentence if there is any
                    if (data.length > 0) dataTemp.push(<span>{data}</span>);
                    return (<span>{dataTemp}</span>)
                }
            }
        }
    }

    scrollToAnker = (subChapter) => {
        var ankerPoint = document.getElementById(this.state.subChapter);
        if (ankerPoint) {
            ankerPoint.scrollIntoView();
        } else {
            // no ankerPoint mostly means new chapter, scroll to top
            var top = document.getElementById("readerContainer");
            top.scrollTop = 0;
        }

    }

    debounce = (func, wait, immediate) => {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    onReset = () => {
        this.setState({searchTerm: ""})
    }

    handleCloseModal = () => {
        this.setState({noSubError: true, modalState: "closed", openModal: false})
    }

    onHandleDirectionsButton(direction) {
        var result;
        if (direction === "left") {
            result = this.getChapterBefore();
            if (result) {
                this.handleChapterSelected(result.chapter.chapter, result.chapter.subChapterName, result.index)
            }

        } else {
            result = this.getChapterAfter();
            if (result) {
                this.handleChapterSelected(result.chapter.chapter, result.chapter.subChapterName, result.index)
            }
        }
    }

    getChapterBefore = () => {
        const {currentChapter, currentBook} = this.props;
        if (!currentChapter || !currentBook) return null;
        const currentChapterName = currentChapter.chapterName;
        const allChapters = currentBook.chapters;
        var index = null;
        for (var i = 0; i < allChapters.length; i++) {
            //eslint-disable-next-line
            if (allChapters[i].chapterName == currentChapterName) {
                index = i - 1;
            }
        }
        var second = false;
        for (var x = index; x >= 0; x--) {
            if (allChapters[x].className === "TOC-E1" || allChapters[x].className === "TOC-E2") {
                if (!second) {
                    second = true;
                    continue;
                } else {
                    return {chapter: allChapters[x], index: x};
                }

            }
        }
        return null;
    }

    getChapterAfter = () => {
        const {currentChapter, currentBook} = this.props;
        if (!currentChapter || !currentBook) return null;
        const currentChapterName = currentChapter.chapterName;
        const allChapters = currentBook.chapters;
        var index = null;
        for (var i = 0; i < allChapters.length; i++) {
            //eslint-disable-next-line
            if (allChapters[i].chapterName == currentChapterName) {
                index = i;
            }
        }

        for (var x = index + 1; x < allChapters.length; x++) {
            if (allChapters[x].className === "TOC-E1" || allChapters[x].className === "TOC-E2") {
                return {chapter: allChapters[x], index: x};
            }
        }
        return null;
    }


    toggleSidebar = () => {
        this.setState({openSidebar: !this.state.openSidebar});
    }

    // RENDER FUNCTIONS
    renderContentNextButton = (direction) => {
        var height = null;
        var Icon = RightIcon;
        if (direction === "left") {
            Icon = LeftIcon

            if (this.getChapterBefore() == null) {
                return <div/>;
            }
        }

        if (this.getChapterAfter() == null) {
            return null;
        }

        return (
            <div onClick={() => {
                this.onHandleDirectionsButton(direction)
            }} style={{
                height: "auto",
                width: "auto",
                display: "inline-block",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 0,
                padding: "5px 20px 5px 10px",
                float: "right",
                marginBottom: "40px",
                marginTop: "20px"
            }}
                 className={"roundedMagnifier"}
            >
                <Icon style={{
                    color: "white",
                    width: (height ? (height / 45) * 28 : 28),
                    height: (height ? (height / 45) * 28 : 28)
                }}/> {direction === "left" ? 'Zurück' : this.state.nextButton}
            </div>
        )

    }

    renderMetaInformation() {
        // clear all previous tags
        let metaTags = document.head.getElementsByTagName("meta");
        // create list with tags to remove
        let removeTags = [];
        for (let i = 0; i < metaTags.length; i++) {
            if (metaTags[i].name === "title" || metaTags[i].name === "description" || metaTags[i].name === "keywords") {
                removeTags.push(metaTags[i]);
            }
        }
        for (let i = removeTags.length - 1; i >= 0; --i) {
            removeTags[i].remove();
        }

        // clear all previous tags
        metaTags = document.head.getElementsByTagName("title");
        for (let i = metaTags.length - 1; i >= 0; --i) {
            metaTags[i].remove();
        }

        if (this.props.currentBook) {
            const title = document.createElement('title');
            let titleText = "";
            let author = String(this.props.currentBook.originalAuthor);
            author = author.replace(/Von /, "");
            author = author.replace(/von /, "");
            let bookTitle = this.props.currentBook.title;
            bookTitle = bookTitle.replace(/Von /, "");
            bookTitle = bookTitle.replace(/von /, "");

            if (this.props.currentBook.metaTitle) {
                titleText = this.props.currentBook.metaTitle + " von " + author + " | Lektüren verstehen";
            } else {
                titleText = this.props.currentBook.title ? bookTitle + " von " + author + " | Lektüren verstehen" : 'Lektüren verstehen';
            }
            if (titleText.length === 0)
                title.innerHTML = "Lektüren verstehen";
            else
                title.innerHTML = titleText;
            document.head.appendChild(title);

            let meta = document.createElement('meta');
            meta.name = "description";
            meta.content = this.props.currentBook.metaDescription + " | Lektüren verstehen";
            if (meta.content !== undefined && meta.content !== 'undefined') document.head.appendChild(meta);
            meta = document.createElement('meta');
            meta.name = "author";
            meta.content = this.props.currentBook.metaAuthor
            if (meta.content !== undefined && meta.content !== 'undefined') document.head.appendChild(meta);

            let link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', document.location.protocol + '//' + document.location.host + addSlashes(this.props.currentBook.link));
            document.head.appendChild(link);

        }


    }

    renderZusatz() {
        if (this.props.currentChapter.zusatz) {
            let materialien = this.props.currentChapter.zusatz;
            // create emtpy div
            let container = [];
            for (let i = 0; i < materialien.length; i++) {
                let material = materialien[i];
                let source = apiAddress + '/api/v1/content/stream/' + material;
                // get file ending to determin the type
                let fileType = material.split('.').pop();
                let title = material.split('/').pop();
                let titleReadable = title.split('.' + fileType)[0];
                titleReadable = titleReadable.replace(/_/g, ' ');
                switch (fileType) {
                    case 'mp3':
                        container.push(
                            <div>
                                <div className='zusatzTitle'>{titleReadable}</div>
                                <audio controls onContextMenu={(e) => {
                                    e.preventDefault();
                                    return false
                                }} controlsList="nodownload">
                                    <source src={source} type='audio/mpeg'/>
                                    Your browser does not support the audio element.
                                </audio>
                            </div>
                        )
                        break;
                    case 'mp4':
                        container.push(
                            <div>
                                <div className='zusatzTitle'>{titleReadable}</div>
                                <video preload="metadata" id='videoPlayer' controls controlsList="nodownload"
                                       height='100%' width='100%' onContextMenu={(e) => {
                                    e.preventDefault();
                                    return false
                                }}>
                                    <source src={source + '#t=0.5'} type='video/mp4'/>
                                </video>
                            </div>
                        )
                        break;
                    case 'webm':
                        container.push(
                            <div>
                                <div className='zusatzTitle'>{titleReadable}</div>
                                <video preload="metadata" id='videoPlayer' controls controlsList="nodownload"
                                       height='100%' width='100%' onContextMenu={(e) => {
                                    e.preventDefault();
                                    return false
                                }}>
                                    <source src={source + '#t=0.5'} type='video/webm'/>
                                </video>
                            </div>
                        )
                        break;
                    case 'pdf':
                        source = apiAddress + '/api/v1/content/pdf/' + material;
                        if (isMobile) {
                            container.push(
                                <div>
                                    <div className='zusatzTitle'>{titleReadable}</div>
                                    <a href={source} target="blank">{titleReadable + "." + fileType}</a>
                                </div>
                            )
                        } else {
                            container.push(<div
                                style={{justifyContent: "center", display: "flex", flexDirection: "column"}}>
                                <div className='zusatzTitle'>{titleReadable}</div>
                                <PdfComponent src={source}/>
                            </div>)
                        }

                        break;
                    case 'png':
                        container.push(
                            <div>
                                <div className='zusatzTitle'>{titleReadable}</div>
                                <img alt={titleReadable} src={source} width="100%"/>
                            </div>
                        )
                        break;
                    case 'jpg':
                        container.push(
                            <div>
                                <div className='zusatzTitle'>{titleReadable}</div>
                                <img alt={titleReadable} src={source} width="100%"/>
                            </div>
                        )
                        break;
                    default:
                        break;
                }
            }

            return container;
        }
        return null;
    }

    renderMobile = () => {
        const {currentBook, currentChapter} = this.props;
        let author = "";
        let title = "";
        let content = "";

        let searchbar = document.getElementById("contentSearch");
        if (searchbar && !this.hasListener) {
            searchbar.firstChild.firstChild.addEventListener("focus", () => {
                document.getElementById("contentSearch").firstChild.classList.add("searchfocus");
            });
            searchbar.firstChild.firstChild.addEventListener("blur", () => {
                document.getElementById("contentSearch").firstChild.classList.remove("searchfocus");
            });
            this.hasListener = true;
        }

        if (currentBook) {
            author = currentBook.author;
            title = currentBook.title;

        }

        if (!currentBook || !currentBook.title) return null;

        if (currentChapter) {
            content = ReactHtmlParser(currentChapter.content, {transform: this.transform})
        }
        return (
            <div style={{height: this.state.windowHeight, background: "white", padding: 0}}
                 className={"main-content-container container-fluid " + this.state.format}>
                <div style={{display: 'flex', height: "100%", flexDirection: "column"}}>

                    <div id="contentContainer" ref={(ref) => {
                        this.contentContainer = ref;
                    }} style={{
                        marginTop: "148px",
                        scrollBehavior: "smooth",
                        padding: "4px",
                        paddingTop: 15,
                        paddingLeft: 10,
                        paddingRight: 10,
                        paddingBottom: 15,
                        boxShadow: "0 0 40px -12px #7a7a7a80"
                    }}>
                        {this.state.lockPage &&
                            <div id="lockBg"
                                 style={{
                                     position: "absolute",
                                     top: 84,
                                     left: 0,
                                     overflow: "hidden",
                                     display: "flex",
                                     alignItems: "center",
                                     justifyContent: "center",
                                     height: document.getElementById("contentContainer") != null ? document.getElementById("contentContainer").offsetHeight : "100%",
                                     width: document.getElementById("contentContainer") != null ? document.getElementById("readerContainer").offsetWidth : "100%",
                                     background: "#00000080",
                                     zIndex: 1232
                                 }}>
                                <div>
                                    {/*eslint-disable-next-line*/}
                                    <Lottie
                                        width={50}
                                        options={{
                                            animationData: loader,
                                        }}/>
                                </div>
                            </div>}
                        <div style={{display: "flex", alignItems: "center"}}>
                            <div style={{flex: 1}}>
                                <div style={{
                                    color: "black",
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    marginBottom: 0,
                                    marginTop: 5
                                }}>{title}</div>
                                <div style={{color: "#959595", fontSize: 12}}>{author}</div>
                            </div>
                            <IconButton className="noOutline" ref={(ref) => {
                                this.toggleContentListElement = ref;
                            }} onClick={() => {
                                this.setState({contentListOpen: !this.state.contentListOpen})
                            }}>
                                <TocIcon/>
                            </IconButton>
                        </div>

                        {this.state.contentListOpen && <div>
                            <div id="contentSearch" style={{width: "100%", marginBottom: 20, marginTop: 15}}>

                                <SearchBar inputStyles={{fontSize: 12}} theme="viewer" height={40} resetable={true}
                                           searchTerm={this.state.searchTerm}
                                           styles={{width: "100%", background: "white", border: "1px solid #dfe1e5"}}
                                           onReset={this.onReset} onSubmit={this.props.onSubmit}
                                           onChange={async (value) => {
                                               this.setState({searchTerm: value})
                                           }} placeHolder="Im Titel suchen" size="dynamic" colorScheme="white"/>
                            </div>

                            <div style={{
                                color: "rgba(0,0,0,0.75)",
                                fontSize: 16,
                                fontWeight: 600,
                                marginBottom: 15,
                                marginTop: 10
                            }}>Inhaltsverzeichnis
                            </div>

                            {currentBook && currentBook.chapters.map(
                                (chapter, index) => (
                                    <ChapterItem
                                        key={index}
                                        searchTerm={this.state.searchTerm}
                                        chapter={chapter}
                                        index={index}
                                        onChapterSelected={this.handleChapterSelected}
                                        currentChapterId={this.state.currentChapterId}
                                        searchResults={this.props.searchResultChapters}
                                    />
                                )
                            )
                            }
                        </div>
                        }
                        {this.state.contentListOpen && this.state.togglePageUpButton && (
                            <div className="scrollTop" onClick={() => {
                                this.contentContainer.scrollTop = 0;
                                this.setState({togglePageUpButton: false});
                            }}>

                                <ArrowUpwardIcon/>
                            </div>)
                        }
                    </div>
                    <div id="readerContainer" ref={(ref) => {
                        this.readerContainer = ref;
                    }}
                         style={{
                             scrollBehavior: "smooth",
                             flex: 3,
                             height: "100%",
                             width: "100%",
                             overflow: (this.state.modalState === "closed" ? "auto" : "hidden")
                         }}
                    >
                        <div className="page-container" style={{marginTop: "30px", marginBottom: "30px"}}>
                            {this.renderContentNextButton("right")}
                        </div>
                        {this.state.openModal &&
                            <Suspense fallback={renderLoader()}>
                                <ViewerModal
                                    checkoutPurchase={this.state.checkoutPurchase}
                                    paymentId={this.state.paymentId}
                                    onError={() => this.setState({
                                        paymentId: "",
                                        subId: "",
                                        checkoutPurchase: false,
                                        checkoutSubscribe: false
                                    })}
                                    checkoutSubscribe={this.state.checkoutSubscribe}
                                    subId={this.state.subId}
                                    noSubError={this.state.noSubError}
                                    open={this.state.openModal}
                                    handleClose={this.handleCloseModal.bind(this)}
                                    readerHeight={this.state.windowHeight - 120}
                                    readerContainer={this.readerContainer}/>
                            </Suspense>
                        }
                        <span id="topAnker" style={{display: "none"}}/>
                        {/* Zusatzmaterial-Overview falls vorhanden oder erstes Chapter !*/}
                        {this.props.currentChapter && this.props.currentChapter.chapterName === "ch01" &&
                            (this.renderZusatzBoxOverview(this.props.currentBook.mediaTypes))
                        }
                        {this.props.currentChapter && this.props.currentChapter.zusatz && this.props.currentChapter.zusatz.length > 0 && (
                            this.renderZusatzBoxKapitel()
                        )}
                        {content}
                        {/* Zusatzmaterial falls vorhanden !*/}
                        {this.props.currentChapter && this.props.currentChapter.zusatz && this.props.currentChapter.zusatz.length > 0 && (
                            <div className="page-container">
                                <div className="zusatz">Zusatzmaterial</div>
                                <div>
                                    {this.renderZusatz()}
                                </div>
                            </div>)}
                        <div className="page-container" style={{display: "flex", justifyContent: 'space-between'}}>
                            {this.renderContentNextButton("left")}
                            {this.renderContentNextButton("right")}
                        </div>

                        {!this.state.contentListOpen && this.state.togglePageUpButtonReader && (
                            <div className="scrollTop" onClick={() => {
                                this.readerContainer.scrollTop = 0;
                                this.setState({togglePageUpButtonReader: false});
                            }}>

                                <ArrowUpwardIcon/>
                            </div>)}
                        <MainFooter transparent={false}/>
                    </div>

                </div>
            </div>
        )
    }


    renderModal() {
        return (
            <Suspense fallback={renderLoader()}>
                <ViewerModal
                    checkoutPurchase={this.state.checkoutPurchase}
                    paymentId={this.state.paymentId}
                    checkoutSubscribe={this.state.checkoutSubscribe}
                    onError={() => this.setState({
                        paymentId: "",
                        subId: "",
                        checkoutPurchase: false,
                        checkoutSubscribe: false
                    })}
                    subId={this.state.subId} noSubError={this.state.noSubError}
                    open={this.state.openModal}
                    handleClose={this.handleCloseModal.bind(this)}
                    readerHeight={this.state.windowHeight - 120}
                    readerWidth={this.state.readerWidth}/>
            </Suspense>

        )
    }

    renderZusatzBoxOverview(mediaTypes) {
        let mediaImgUrls = {};

        for (let mediaType in mediaTypes) {
            switch (mediaTypes[mediaType]) {
                case "image":
                    mediaImgUrls.image = imageSpecial;
                    break;
                case "video":
                    mediaImgUrls.video = videoSpecial;
                    break;
                case "audio":
                    mediaImgUrls.audio = audioSpecial;
                    break;
                default:
                    break;
            }
        }
        let elements = mediaTypes.map((mediaType, index) => {
            let MediaType = '';
            switch (mediaType) {
                case "image":
                    MediaType = "Bild";
                    break;
                case "video":
                    MediaType = "Video";
                    break;
                case "audio":
                    MediaType = "Audio";
                    break;
                default:
                    break;
            }
            if (MediaType !== '') {
                return <Tooltip key={index} title={mediaType}>
                    <div
                        className="ZusatzBoxOverviewMedia pt-3 pr-5 d-flex flex-column justify-content-center align-items-center">
                        <img alt={MediaType} className="zusatzIcon" data-index={index} src={mediaImgUrls[mediaType]}/>
                        <div className="zusatzFont">{MediaType}</div>
                    </div>
                </Tooltip>
            }
            return null;
        });
        if (this.getChapterAfter() == null) {
            return null;
        }
        return (
            !empty(elements) ?
                <div className="page-container" style={{marginTop: "20px"}}>
              <span className="zusatzFont" style={{fontSize: "1.5em", textTransform: "uppercase"}}>
                Zusatzmaterialien in diesem Buch:
              </span>
                    <div className="d-flex flex-wrap flex-row justify-content-start">
                        {elements}
                    </div>
                </div> : null);

    }

    renderZusatzBoxKapitel = () => {
        if (this.props.currentChapter && this.props.currentChapter.zusatz) {
            let materialien = this.props.currentChapter.zusatz;
            // create emtpy div
            //let container = [];
            // collect items
            let itemsAudio = [];
            let itemsVideo = [];
            let itemsImage = [];
            let itemsText = [];
            for (let i = 0; i < materialien.length; i++) {
                let material = materialien[i];
                // get file ending to determin the type
                let fileType = material.split('.').pop();
                let title = material.split('/').pop();
                let titleReadable = title.split('.' + fileType)[0];
                titleReadable = titleReadable.replace(/_/g, ' ');
                //let index = i;
                switch (fileType) {
                    case 'mp3':
                        itemsAudio.push(
                            <MenuItem key={i}
                                      value={{i}}>{titleReadable}</MenuItem>
                        )
                        break;
                    case 'mp4':
                        itemsVideo.push(
                            <MenuItem key={i} value={{i}}>{titleReadable}</MenuItem>
                        )
                        break;
                    case 'png':
                        itemsImage.push(
                            <MenuItem key={i} value={{i}}>{titleReadable}</MenuItem>
                        )
                        break;
                    case 'jpg':
                        itemsImage.push(
                            <MenuItem key={i} value={{i}}>{titleReadable}</MenuItem>
                        )
                        break;
                    default:
                        break;
                }


            } // for loop end
            let result = [];
            if (itemsAudio.length > 0) {
                let zusatzAudio = (
                    <Tooltip title={"Audiomaterial"}>
                        <div
                            className="ZusatzBoxKapitelAudio pt-3 pr-5 d-flex flex-column justify-content-center align-items-center"
                            onClick={this.scrollToZusatz}>
                            <img alt="Audio"
                                 className="zusatzKapitelIcon"
                                 src={audioSpecial}/>
                        </div>

                    </Tooltip>
                );
                result.push(zusatzAudio);
            }

            if (itemsVideo.length > 0) {
                let zusatz = (
                    <Tooltip title={"Videomaterial"}>
                        <div
                            className="ZusatzBoxKapitelVideo pt-3 pr-5 d-flex flex-column justify-content-center align-items-center"
                            onClick={this.scrollToZusatz}>
                            <img alt="Audio"
                                 className="zusatzKapitelIcon"
                                 src={videoSpecial}/>
                        </div>

                    </Tooltip>
                );
                result.push(zusatz);
            }

            if (itemsImage.length > 0) {
                let zusatz = (
                    <Tooltip title={"Bildmaterial"}>
                        <div
                            className="ZusatzBoxKapitelBild pt-3 pr-5 d-flex flex-column justify-content-center align-items-center"
                            onClick={this.scrollToZusatz}>
                            <img alt="Audio"
                                 className="zusatzKapitelIcon"
                                 src={imageSpecial}/>
                        </div>

                    </Tooltip>
                );
                result.push(zusatz);
            }

            if (itemsText.length > 0) {
                let zusatz = (
                    <Tooltip title={"Textmaterial"}>
                        <div
                            className="ZusatzBoxKapitelText pt-3 pr-5 d-flex flex-column justify-content-center align-items-center"
                            onClick={this.scrollToZusatz}>
                            <img alt="Audio"
                                 className="zusatzKapitelIcon"
                                 src={textSpecial}/>
                        </div>

                    </Tooltip>
                );
                result.push(zusatz);
            }

            return (<div className="d-flex flex-wrap page-container mb-0">{result}</div>);
        }
        return null;
    }


    render() {
        let searchbar = document.getElementById("contentSearch");
        if (searchbar && !this.hasListener) {
            searchbar.firstChild.firstChild.addEventListener("focus", () => {
                document.getElementById("contentSearch").firstChild.classList.add("searchfocus");
            });
            searchbar.firstChild.firstChild.addEventListener("blur", () => {
                document.getElementById("contentSearch").firstChild.classList.remove("searchfocus");
            });
            this.hasListener = true;
        }

        if (this.state.loading) {
            return (<div style={{position: "fixed", left: "50%", top: "50%", marginLeft: "-35px"}}>
                {/*eslint-disable-next-line*/}
                <Lottie style={{width: "70px", margin: "0px"}}
                        options={{
                            animationData: loader,
                        }}/></div>)
        }
        if (isMobile) {
            return this.renderMobile();
        }
        const {currentBook, currentChapter} = this.props;
        let author = "";
        let title = "";
        let content = "";

        if (currentBook) {
            author = currentBook.originalAuthor;
            title = currentBook.title;
        }

        if (!currentBook || !currentBook.title) return null;

        if (currentChapter) {
            content = ReactHtmlParser(currentChapter.content, {transform: this.transform})
        }

        return (
            <div style={{height: this.state.windowHeight - 120, background: "white", padding: 0, marginTop: "114px"}}
                 className={"main-content-container container-fluid " + this.state.format}>
                <div style={{display: 'flex', height: "100%", flexDirection: "row"}}>
                    <div id="contentContainer" ref={(ref) => {
                        this.contentContainer = ref;
                    }} style={{
                        flex: this.state.openSidebar ? 1 : 0,
                        overflow: this.state.openSidebar ? "auto" : "hidden",
                        height: this.state.windowHeight - 120,
                        minWidth: "80px",
                        padding: "4px",
                        paddingTop: 20,
                        paddingBottom: 100,
                        paddingLeft: this.state.openSidebar ? 40 : 10,
                        boxShadow: "0 0 40px -12px #7a7a7a80"
                    }}>
                        {!this.state.openSidebar && (<div style={{textAlign: "end"}}>
                            <IconButton className="noOutline" aria-label="close" onClick={this.toggleSidebar}>
                                <TocIcon style={{fontSize: "1.5em"}}/>
                            </IconButton>
                        </div>)}
                        <div style={{
                            opacity: this.state.openSidebar ? 1 : 0,
                            transition: this.state.openSidebar ? "all 0.2s cubic-bezier(0.6, 0.04, 0.98, 0.335)" : "all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1)"
                        }}>
                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                <div>
                                    <h1 style={{
                                        color: "black",
                                        fontSize: 18,
                                        fontWeight: "bold",
                                        marginBottom: 0,
                                        marginTop: 5
                                    }}>{title}</h1>
                                    <h2 style={{color: "#959595", fontSize: 12, marginBottom: 15}}>{author}</h2>
                                </div>
                                <div style={{textAlign: "end"}}>
                                    <IconButton className="noOutline" aria-label="close" onClick={this.toggleSidebar}>
                                        {this.state.openSidebar && <ArrowBackIosIcon style={{fontSize: "1.3em"}}/>}
                                        {!this.state.openSidebar && <TocIcon style={{fontSize: "1.5em"}}/>}
                                    </IconButton>
                                </div>
                            </div>

                            <div id="contentSearch" style={{width: "85%", marginBottom: 20}}>
                                <SearchBar inputStyles={{fontSize: 12}}
                                           theme="viewer" height={40}
                                           resetable={true}
                                           searchTerm={this.state.searchTerm}
                                           styles={{width: "100%", background: "white", border: "1px solid #dfe1e5"}}
                                           onReset={this.onReset}
                                           onSubmit={this.props.onSubmit}
                                           onChange={async (value) => {
                                               this.setState({searchTerm: value});
                                               await this.searchBookDebounced(value);
                                           }}
                                           placeHolder="Im Titel suchen"
                                           size="dynamic"
                                           colorScheme="white"/>
                            </div>
                            <div style={{
                                color: "rgba(0,0,0,0.75)",
                                fontSize: 16,
                                fontWeight: 600,
                                marginBottom: 15,
                                marginTop: 10
                            }}>Inhaltsverzeichnis
                            </div>

                            {currentBook && currentBook.chapters.map(
                                (chapter, index) => (
                                    <ChapterItem
                                        key={index}
                                        searchTerm={this.state.searchTerm}
                                        chapter={chapter}
                                        index={index}
                                        onChapterSelected={this.handleChapterSelected}
                                        currentChapterId={this.state.currentChapterId}
                                        searchResults={this.props.searchResultChapters}
                                    />
                                )
                            )
                            }
                            {this.state.contentListOpen && this.state.togglePageUpButton && (
                                <div className="scrollTop" onClick={() => {
                                    this.contentContainer.scrollTop = 0;
                                    this.setState({togglePageUpButton: false});
                                }}>

                                    <ArrowUpwardIcon/>
                                </div>)}
                        </div>
                    </div>

                    {/*eslint-disable-next-line*/}
                    <div id="readerContainer" ref={(e) => {
                        if (e && e.offsetWidth !== this.state.readerWidth) {
                            this.setState({readerWidth: e.offsetWidth});
                            this.readerContainer = e;
                        }
                    }} style={{
                        scrollBehavior: "smooth",
                        flex: 3,
                        height: this.state.windowHeight - 120,
                        width: "100%",
                        overflow: (this.state.modalState === "closed" ? "auto" : "hidden")
                    }}>
                        <div className="page-container" style={{marginTop: "30px", marginBottom: "30px"}}>
                            {this.renderContentNextButton("right")}
                        </div>
                        {this.state.lockPage &&
                            <div id="lockBg"
                                 style={{
                                     position: "absolute",
                                     overflow: "hidden",
                                     display: "flex",
                                     justifyContent: "center",
                                     alignItems: "center",
                                     height: document.getElementById("readerContainer") != null ? document.getElementById("readerContainer").offsetHeight : "100%",
                                     width: document.getElementById("readerContainer") != null ? document.getElementById("readerContainer").offsetWidth : "100%",
                                     background: "#00000080"
                                 }}
                            >
                                <div><Lottie style={{width: "100px", margin: "0px"}}
                                             options={{
                                                 animationData: loader,
                                             }}
                                /></div>
                            </div>}
                        {this.state.openModal && this.props.currentChapter && this.renderModal()}
                        {/* Zusatzmaterial-Overview falls vorhanden oder erstes Chapter !*/}
                        {this.props.currentChapter && this.props.currentChapter.chapterName === "ch01" &&
                            (this.renderZusatzBoxOverview(this.props.currentBook.mediaTypes))
                        }
                        {this.props.currentChapter && this.props.currentChapter.zusatz && this.props.currentChapter.zusatz.length > 0 && (
                            this.renderZusatzBoxKapitel()
                        )}
                        {content}
                        {/* Zusatzmaterial falls vorhanden !*/}
                        {this.props.currentChapter && this.props.currentChapter.zusatz && this.props.currentChapter.zusatz.length > 0 && (
                            <div className="page-container">
                                <div className="zusatz">Zusatzmaterial</div>
                                <div>
                                    {this.renderZusatz()}
                                </div>
                            </div>)}
                        <div className="page-container" style={{
                            marginBottom: 50,
                            marginTop: 50,
                            marginLeft: 20,
                            marginRight: 20,
                            display: "flex",
                            justifyContent: 'space-between'
                        }}>
                            {this.renderContentNextButton("left")}
                            {this.renderContentNextButton("right")}
                        </div>
                        {!this.state.contentListOpen && this.state.togglePageUpButtonReader &&
                            (<div className="scrollTop"
                                  onClick={() => {
                                      this.readerContainer.scrollTop = 0;
                                      this.setState({togglePageUpButtonReader: false});
                                  }}>
                                <ArrowUpwardIcon/>
                            </div>)}
                        <MainFooter transparent={false}/>
                    </div>
                </div>
            </div>
        )
    }
}

Viewer.propTypes = {
    /**
     * The small stats data.
     */

};

Viewer.defaultProps = {};

const mapStateToProps = state => ({
    currentChapter: state.content.currentChapter,
    currentBook: state.content.currentBook,
    books: state.content.books,
    authenticated: state.authentication.authenticated,
    searchTerm: state.content.searchTerm,
    searchResultChapters: state.content.searchResultChapters
});

const mapDispatchToProps = dispatch => ({
    fetchBookByAuthorAndTitle: (author, title, successCb, errorCb) => dispatch(fetchBookByAuthorAndTitle(author, title, successCb, errorCb)),
    fetchChapterById: (chapterId, successCb, errorCb) => dispatch(fetchChapterById(chapterId, successCb, errorCb)),
    orderBook: (bookid, successCb, errorCb) => dispatch(orderBook(bookid, successCb, errorCb)),
    login: (email, password, successCb, errorCb) => dispatch(loginUser(email, password, successCb, errorCb)),
    logoutUser: (scb, ecb) => dispatch(logout(scb, ecb)),
    searchInBook: (bookid, searchTerm, successCb, errorCb) => dispatch(searchInBook(bookid, searchTerm, successCb, errorCb)),
    getUserActiveSubscription: (searchterm, successCb, errorCb) => dispatch(getUserActiveSubscription(searchterm, successCb, errorCb))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Viewer));
